//dựa theo enum SendMessageType trong Backend
export const sendMessageTypeEnum = {
  Sms: 0,
  Zalo: 1,
  Email: 2,
  TrungTam : 3,
  PhongKham : 4
}